module.exports = __webpack_public_path__ + "static/img/contact_logo4_h.84a5464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contact_logo4_h.png
// module id = Hshb
// module chunks = 1